import React from 'react';
import { UsageStatistic } from 'components/UsageStatistic';

export const Scanning = () => {
  return <UsageStatistic style={{ paddingTop: '1rem' }} />;
};
